var _g, _g2, _g3, _g4, _g5, _circle, _g6, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnective(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 154,
    viewBox: "0 0 146 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_577_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.663 77.0002C101.663 94.4689 98.1149 110.111 92.5423 121.256C86.8649 132.611 79.6693 138.301 72.762 138.301C65.8547 138.301 58.6591 132.611 52.9818 121.256C47.4091 110.111 43.8613 94.4689 43.8613 77.0002C43.8613 59.5315 47.4091 43.8896 52.9818 32.7444C58.6591 21.3899 65.8547 15.6995 72.762 15.6995C79.6693 15.6995 86.8649 21.3899 92.5423 32.7444C98.1149 43.8896 101.663 59.5315 101.663 77.0002Z",
    stroke: "url(#paint0_linear_577_1415)",
    strokeWidth: 7,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_577_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.2127 51.971C102.341 60.7054 114.114 71.599 120.979 81.9979C127.974 92.592 129.304 101.669 125.85 107.651C122.396 113.633 113.87 117.02 101.198 116.26C88.7597 115.513 73.4394 110.765 58.311 102.03C43.1825 93.2958 31.4101 82.4022 24.5444 72.0034C17.5497 61.4092 16.2195 52.3322 19.6733 46.35C23.1272 40.3678 31.6532 36.9813 44.3254 37.7417C56.7639 38.4881 72.0842 43.2366 87.2127 51.971Z",
    stroke: "url(#paint1_linear_577_1415)",
    strokeWidth: 7,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_577_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.2113 102.027C72.0831 110.761 56.7631 115.51 44.325 116.257C31.6532 117.017 23.1278 113.631 19.6744 107.65C16.2211 101.669 17.5514 92.5924 24.5462 81.9987C31.412 71.6003 43.1844 60.7072 58.3126 51.9729C73.4408 43.2386 88.7607 38.49 101.199 37.7432C113.871 36.9824 122.396 40.3685 125.849 46.3499C129.303 52.3312 127.972 61.4075 120.978 72.0012C114.112 82.3995 102.34 93.2927 87.2113 102.027Z",
    stroke: "url(#paint2_linear_577_1415)",
    strokeWidth: 7,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_577_1415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8,
    cy: 16.8,
    rx: 16.8,
    ry: 16.8,
    transform: "matrix(-1 0 0 1 89.562 60.2002)",
    fill: "#63CADA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8,
    cy: 16.8,
    rx: 16.8,
    ry: 16.8,
    transform: "matrix(-1 0 0 1 89.562 60.2002)",
    fill: "url(#paint3_radial_577_1415)",
    fillOpacity: 0.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_577_1415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.10909,
    cy: 6.10909,
    rx: 6.10909,
    ry: 6.10909,
    transform: "matrix(0.991249 -0.132002 -0.132002 -0.991249 62.9336 81.4023)",
    fill: "#E7FDFF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.756,
    cy: 77,
    r: 11.997,
    fill: "url(#paint4_radial_577_1415)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_577_1415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7616,
    cy: 44.6022,
    rx: 12.0023,
    ry: 12.0023,
    fill: "url(#paint5_radial_577_1415)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7618,
    cy: 110.077,
    rx: 11.9976,
    ry: 11.9976,
    fill: "url(#paint6_radial_577_1415)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7675,
    cy: 77,
    rx: 12,
    ry: 12,
    fill: "url(#paint7_radial_577_1415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_577_1415",
    x: 30.3613,
    y: 0.199463,
    width: 88.8013,
    height: 153.602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_1415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_577_1415",
    x: 4.33545,
    y: 22.1372,
    width: 140.853,
    height: 109.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_1415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_577_1415",
    x: 4.33691,
    y: 22.1387,
    width: 140.85,
    height: 109.722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_1415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_577_1415",
    x: 49.9619,
    y: 52.7002,
    width: 48.6001,
    height: 48.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_1415",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_577_1415",
    result: "effect3_innerShadow_577_1415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_577_1415",
    x: 46.3812,
    y: 52.7384,
    width: 43.6033,
    height: 43.6038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.84601,
    result: "effect1_foregroundBlur_577_1415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_577_1415",
    x: 51.5122,
    y: 21.041,
    width: 47.1221,
    height: 47.1224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.31177
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.77943
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_1415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_1415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_1415",
    x1: 150.137,
    y1: 79.0208,
    x2: 38.6413,
    y2: 75.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_1415",
    x1: 113.2,
    y1: 11.0001,
    x2: 54.4008,
    y2: 105.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_577_1415",
    x1: 109.697,
    y1: 145.015,
    x2: 57.0023,
    y2: 46.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_577_1415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.873 4.08166) rotate(146.296) scale(35.1791 44.9744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_577_1415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.976 86.3795) rotate(-57.5402) scale(21.1337 306.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_577_1415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9781 53.9858) rotate(-57.5402) scale(21.143 306.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_577_1415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9817 119.457) rotate(-57.5402) scale(21.1348 306.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_577_1415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9857 86.3818) rotate(-57.5402) scale(21.1389 306.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnective);
export default __webpack_public_path__ + "static/media/connective.bef0bc19.svg";
export { ForwardRef as ReactComponent };